import { colors } from '../colors';
import { StepperTheme } from './types';

export const stepper: StepperTheme = {
    sizes: {
        S: {
            counterSize: '120px',
        },
        M: {
            counterSize: '140px'
        },
        L: {
            counterSize: '160px'
        }
    },
    activeColor: colors.purple.primary,
    inactiveColor: '#F3F0FD',
};
